const PAGINATION_LABEL = {
  FINISHED_LOADING: 'All courses loaded',
  LOADING: 'Loading courses',
  LOAD_MORE: 'Load more courses',
};

export default PAGINATION_LABEL;
